import { Input, Select, InputAdornment } from '@material-ui/core';
import WorkspaceIcon from '@material-ui/icons/GroupWork';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

const styles = {
	icon: {
		color: 'white'
	},
	disabledIcon: {
		visibility: 'hidden'
	},
	underline: {
		'&::before': {
			borderColor: 'white'
		},
		'&::after': {
			borderColor: 'white'
		},
		'&&&&:hover:before': {
			borderBottom: '2px solid white'
		}
	}
};

export const WorkspaceSelect = withStyles(styles)(
	connect(({ user }) => ({ scopeId: user.user.scope.id, availableWorkspaces: user.user.scopes }))((props) => {
		const { scopeId, editable, classes, setScope, availableWorkspaces } = props;
		const showWorkspaceSelect = availableWorkspaces.length > 1;
		if (!showWorkspaceSelect) {
			return null;
		}
		return (
				<FormControl style={{ minWidth: 'auto' }}>
					<Select
						id="workspace"
						value={scopeId}
						// Set scope
						onChange={(event) => setScope(event.target.value)}
						style={{
							color: 'white',
						}}
						input={
							<Input
								classes={{
									underline: classes.underline
								}}
							/>
						}
						startAdornment={
							<InputAdornment position="start">
								<WorkspaceIcon />
							</InputAdornment>
						}
						disabled={!editable}
						classes={{
							icon: editable ? classes.icon : classes.disabledIcon
						}}
					>
						{availableWorkspaces.map((ws) => (
							<MenuItem key={ws.id} value={ws.id}>
								{ws.name}
							</MenuItem>
						))}
					</Select>
				</FormControl>
		);
	})
);



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/workspace/WorkspaceSelect.js